import { MouseEventResult } from "../managers/manager-base";
import { Tool } from "./tool";
import { ToolType } from "./tool";

export class ToolGroup {
    private tools: Tool[] = [];
    private activeActionTool: Tool | null = null;

    constructor(private name: string) {}

    public addTool(tool: Tool) {
        this.tools.push(tool);
    }

    public handleClick(tool: Tool) {
        const toolType = tool.getToolType();
        
        if (toolType === ToolType.Action) {
            // If clicking the same action tool that's already active, deactivate it
            if (this.activeActionTool === tool) {
                tool.deactivate();
                this.activeActionTool = null;
            } else {
                // Otherwise deactivate previous and activate new
                if (this.activeActionTool) {
                    this.activeActionTool.deactivate();
                }
                this.activeActionTool = tool;
                tool.activate();
            }
        } else if (toolType === ToolType.Toggle) {
            // For toggle tools, just toggle their state
            if (tool.isActive()) {
                tool.deactivate();
            } else {
                tool.activate();
            }
        } else {
            // For other tool types, just activate
            tool.activate();
        }
    }

    public getTools(): Tool[] {
        return this.tools;
    }

    public handleMouseMove(x: number, y: number): MouseEventResult | null {
        if (this.activeActionTool) {
            return this.activeActionTool.onMouseMove(x, y);
        }
        return null;
    }

    public handleMouseDown(x: number, y: number): MouseEventResult | null {
        if (this.activeActionTool) {
            return this.activeActionTool.onMouseDown(x, y);
        }
        return null;
    }

    public handleMouseUp(x: number, y: number): MouseEventResult | null {
        if (this.activeActionTool) {
            return this.activeActionTool.onMouseUp(x, y);
        }
        return null;
    }

    public deactivateTool(tool: Tool) {
        if (this.activeActionTool === tool) {
            this.activeActionTool = null;
        }
        tool.deactivate();
    }

    public cancelAction(): void {
        if (this.activeActionTool) {
            if ('cancel' in this.activeActionTool) {
                (this.activeActionTool as any).cancel();
            }
            this.activeActionTool = null;
        }
    }
} 
